var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"main programmazione-siae max-width"},[_c('article',[_c('h1',{staticClass:"title-medium centered regular"},[_vm._v("Effettua il login")]),_vm._v(" "),_c('login-form')],1),_vm._v(" "),_c('snackbar',{attrs:{"states":_vm.states,"state":_vm.state,"showSnackbar":_vm.showSnackbar},on:{"close":function($event){_vm.showSnackbar = false}}})],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0ebefe20","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/vue/components/Login.vue
// module id = 563
// module chunks = 0